/* MTH notify-me trigger (product-state-system).

   ONE document-level delegated click listener opens a PER-PRODUCT Klaviyo popup
   by its form ID. Delegation survives variant re-renders and quick-add modal
   injection, so notify buttons carry NO per-element lifecycle code and can be
   freely replaced by product-info.js on variant change.

   A trigger is anything with [data-klaviyo-form-trigger]; its form id lives in
   [data-klaviyo-form-id]. When the trigger is an <a> (the grid card, which
   points at the PDP as a no-JS fallback), we preventDefault, open the form, and
   only follow the href if Klaviyo never loaded (its app embed is absent on the
   dev/preview theme).

   ASCII-only, in its own asset file (never a {% javascript %} block): non-ASCII
   in a theme JS bundle has truncated scripts.js in this repo before. */

(function () {
  'use strict';

  // Guard against a double-bind if the theme editor re-injects the script.
  if (window.__mthNotifyBound) return;
  window.__mthNotifyBound = true;

  function openForm(id) {
    if (!id) return;
    if (window.klaviyo && typeof window.klaviyo.openForm === 'function') {
      window.klaviyo.openForm(id);
    } else {
      // Klaviyo JS may not have hydrated yet; queue the open so it runs once
      // the app embed loads (same _klOnsite queue the SMS balloon uses).
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', id]);
    }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest ? e.target.closest('[data-klaviyo-form-trigger]') : null;
    if (!trigger) return;

    var id = trigger.getAttribute('data-klaviyo-form-id');
    if (!id) return;

    if (trigger.tagName === 'A') {
      e.preventDefault();
      openForm(id);
      var href = trigger.getAttribute('href');
      if (href) {
        setTimeout(function () {
          if (!window.klaviyo) window.location.href = href;
        }, 1200);
      }
    } else {
      openForm(id);
    }
  });
})();
